export const columns = function () {
    return [
        {
            prop: 'orgName',
            label: '机构名称',
            minWidth: 300
        },
        {
            prop: 'orgNo',
            label: '机构编号',
        },
        {
            prop: 'leader',
            label: '负责人',
        },
        {
            prop: 'tel',
            label: '联系电话',
            minWidth: 150
        },
        {
            prop: 'addr',
            label: '地址',
            minWidth: 200
        },
        {
            prop: 'create_time',
            label: '注册日期',
            minWidth: 200
        },
        // {
        //     prop: 'status',
        //     label: '状态',
        // },
        {
            prop: 'handle',
            label: '操作',
            minWidth: 150,
            fixed: 'right'
        }
    ]
}

export const rules = function () {
    return {
        orgName: [
            { required: true, message: '请输入机构名称', trigger: ['blur', 'change'] },
        ],
        orgNo: [
            { required: true, message: '请输入机构编号', trigger: ['blur', 'change'] },
        ],
        leader: [
            { required: true, message: '请输入负责人', trigger: ['blur', 'change'] },
        ],
        tel: [
            { required: true, message: '请输入联系电话', trigger: ['blur', 'change'] },
        ],
        addr: [
            { required: true, message: '请选择注册日期', trigger: ['blur', 'change'] },
        ]
    }
}

export default {}